import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  Typography, 
  Box, 
  Button
} from '@mui/material';
import { FaArrowLeft } from 'react-icons/fa';
import { 
  Container, 
  Header, 
  HeaderLeft, 
  BackButton, 
  Title, 
  Content, 
  MainSection,
} from '../common/styles';
import { useAlert } from '../../contexts/AlertContext';
import FeedbackReportContent from '../FeedbackSessions/FeedbackReportContent';
import { TabPanel, TabContainer, TabButton } from './styles';

const FeedbackComparison = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { showAlert } = useAlert();
  const [activeTab, setActiveTab] = useState(0);
  const [assignmentIds, setAssignmentIds] = useState([]);

  useEffect(() => {
    // Get the selected assignment IDs from the URL query params
    const params = new URLSearchParams(location.search);
    const ids = params.get('ids')?.split(',') || [];
    
    if (ids.length === 0) {
      showAlert('No assignments selected for comparison', 'error');
      navigate('/feedback-results', { state: { fromComparison: true } });
      return;
    }
    
    setAssignmentIds(ids);
  }, [location.search, navigate, showAlert]);

  const handleBack = () => {
    const scrollState = location.state?.scrollState;
    navigate('/feedback-results', {
      state: {
        fromDetail: true,  // Triggers scroll restoration in useGridNavigation
        scrollState,
        needsRestore: true,
        hideContentUntilScrolled: true,
        timestamp: Date.now()  // Ensure React Router treats this as new state
      }
    });
  };

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  return (
    <Container>
      <Header>
        <HeaderLeft>
          <BackButton onClick={handleBack}>
            <FaArrowLeft /> Back to Results
          </BackButton>
          <Title>Feedback Comparison</Title>
        </HeaderLeft>
      </Header>

      {assignmentIds.length > 0 && (
        <TabContainer>
          {assignmentIds.map((id, index) => (
            <TabButton
              key={id}
              data-active={activeTab === index}
              onClick={() => handleTabChange(index)}
            >
              Assessment {index + 1}
            </TabButton>
          ))}
        </TabContainer>
      )}

      <Content>
        {assignmentIds.length > 0 ? (
          <MainSection>
            {assignmentIds.map((id, index) => (
              <TabPanel
                key={id}
                value={activeTab}
                index={index}
              >
                <FeedbackReportContent assignmentId={id} />
              </TabPanel>
            ))}
          </MainSection>
        ) : (
          <Box sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="h6">No assignments found for comparison</Typography>
            <Button 
              variant="contained" 
              onClick={handleBack}
              sx={{ mt: 2 }}
            >
              Return to Results
            </Button>
          </Box>
        )}
      </Content>
    </Container>
  );
};

export default FeedbackComparison; 